import React, { useState, useRef, useEffect, useCallback } from "react";
import { Html5QrcodeScanner } from "html5-qrcode";
import API from "../../services/api";
import { useNavigate } from "react-router-dom"; 
import { t } from "@lingui/macro";

const CheckQRCode = () => {
  const [isScanning, setIsScanning] = useState(false);
  const [reservation, setReservation] = useState(null);
  const scannerRef = useRef(null);
  const navigate = useNavigate(); 

  const successSound = new Audio("/sounds/success.wav");
  const errorSound = new Audio("/sounds/error.ogg");

  const startScanner = useCallback(() => {
    if (!scannerRef.current) {
      const screenWidth = window.innerWidth;
      let qrboxSize = 250;

      if (screenWidth >= 1024) {
        qrboxSize = 400;
      }
      if (screenWidth >= 1440) {
        qrboxSize = 500;
      }

      scannerRef.current = new Html5QrcodeScanner("scanner", {
        fps: 1,
        qrbox: { width: qrboxSize, height: qrboxSize },
      });

      scannerRef.current.render(handleScanSuccess, handleScanError);
    }
  }, []);

  const stopScanner = () => {
    if (scannerRef.current) {
      scannerRef.current.clear();
      scannerRef.current = null;
    }
  };

  const handleScanSuccess = async (qrHash) => {
    stopScanner();
    try {
      const requestBody = { qrHash };
      const response = await API.post("/api/reservations/check-qr", requestBody);
      const { data } = response;

      if (data) {
        setReservation(data);
        successSound.play();
        navigate("/reservation-check", { state: { reservation: data } }); 
      } else {
        errorSound.play();
      }
      setIsScanning(false);
    } catch (error) {
      errorSound.play();
      setIsScanning(false);
    }
  };

  const handleScanError = (err) => {
    console.error(t`Scan error:`, err);
  };

  useEffect(() => {
    if (isScanning) {
      startScanner();
    } else {
      stopScanner();
    }
    return () => stopScanner();
  }, [isScanning, startScanner]);

  return (
    <div className="flex flex-col items-center gap-4 p-4 w-full max-w-sm mx-auto">
      <button 
        onClick={() => setIsScanning((prev) => !prev)} 
        className="add-new-btn"
      >
        {isScanning ? t`Stop Scan` : t`Start Scan`}
      </button>

      <div
        id="scanner-container"
        className="relative w-full max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl"
      >
        {isScanning && (
          <div
            id="scanner"
            className="w-full h-[250px] md:h-[400px] lg:h-[500px]"
          ></div>
        )}
      </div>
    </div>
  );
};

export default CheckQRCode;
